import { gql } from '@/__generated__';
import { UserDeviceAccess_GetAllDeviceAccessForUserQuery } from '@/__generated__/graphql';

export type UserDeviceAccessEntry =
  UserDeviceAccess_GetAllDeviceAccessForUserQuery['user']['allDeviceAccess'][number];

const GET_ALL_DEVICE_ACCESS_FOR_USER = gql(`#graphql
  query UserDeviceAccess_GetAllDeviceAccessForUser($userId: Int) {
    user(id: $userId) {
      id
      allDeviceAccess {
        direct
        visibleToUser
        device {
          id
          visibleToClient
          operationalStateVisibleToClient
          profile {
            id
            name
            operationalState
            irrigation {
              id
              name
            }
            organization {
              id
              name
            }
          }
        }
        collections {
          id
          name
          type
        }
      }
    }
  }
`);

export default GET_ALL_DEVICE_ACCESS_FOR_USER;
